module.exports = "import React, { PureComponent } from 'react'\n\nclass MyComponent extends PureComponent {\n  render () {\n    // Your render logic here\n  }\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/pure-component.js
 ** module id = 291
 ** module chunks = 0
 **/